/**
 * JWT storage helpers.
 *
 * The architecture (Section 4.1, 5) puts the JWT in Telegram CloudStorage so
 * it survives reinstall and reload. The `cloudStorage` facade in `telegram.ts`
 * already handles the localStorage fallback for non-TG dev contexts, so this
 * module is intentionally thin.
 */
import { cloudStorage } from "./telegram";

const JWT_KEY = "tolkgram_jwt";

export async function loadJwt(): Promise<string | null> {
  return cloudStorage.get(JWT_KEY);
}

export async function saveJwt(jwt: string): Promise<void> {
  await cloudStorage.set(JWT_KEY, jwt);
}

export async function clearJwt(): Promise<void> {
  await cloudStorage.remove(JWT_KEY);
}
